import style from "./aboutus.module.css";
import { Button, ButtonGroup, Col, Row } from "react-bootstrap";
import { Helmet } from "react-helmet-async";
import Newsletter from "../home/newsletter";
import { useNavigate } from "react-router-dom";

const AboutUs = () => {
  const navigate = useNavigate();
  return (
    <>
      <Helmet>
        <title>
          Raise Funds for Churches, Family Services & Community Needs.
        </title>
        <meta
          name="description"
          content="A trusted crowdfunding platform empowering individuals, churches, and organizations to raise funds for family support, pregnancy and adoption services, and community-driven causes. Join FundLife to support essential life-affirming ministries and family care initiatives. "
        />
        <meta
          property="og:description"
          content="A trusted crowdfunding platform empowering individuals, churches, and organizations to raise funds for family support, pregnancy and adoption services, and community-driven causes. Join FundLife to support essential life-affirming ministries and family care initiatives. "
        />
        <meta
          name="keywords"
          content="crowdfunding platform for churches, family support fundraising, pregnancy support donations, adoption fundraising platform, life‑affirming causes crowdfunding, church fundraising, community ministry crowdfunding."
        />
      </Helmet>
      <div className=" ">
        <div className={style.about_banner}>
          <div style={{ height: "135px" }} />
          <div className=" innercontainer py-4 ">
            <div className="container ">
              <div className="text-white fs-1 fw-bold">
                Empowering Change, One Campaign at a Time
              </div>
              <div className="text-white fs-4 my-3 me-1">
                At Fundlife, we’re redefining fundraising to make it simple,
                impactful, and accessible to life-affirming causes.
              </div>
              <ButtonGroup className=" border-0 ">
                <Button
                  variant="danger "
                  className="px-5 redbtn"
                  onClick={() => navigate("/search-campaign")}
                >
                  Browse Campaigns
                </Button>
                {/* <Button
                  variant="outline-secondary"
                  className="px-5 text-white border-1"
                >
                  Watch a Demo
                </Button> */}
              </ButtonGroup>
            </div>
          </div>
        </div>
        <div className=" innercontainer py-4  mt-5 px-3">
          {/* <div className="fs-3 text-center"> About</div> */}
          <div className="d-grid gap-4">
            <div className="fs-1 fw-bold text-center"> About FundLife</div>
            <div className="fs-5" style={{ textAlign: "justify" }}>
              FundLife is a pro-life crowdfunding platform designed to empower
              individuals, churches, and organizations to raise critical funds
              for life-affirming causes. Whether supporting a pregnancy help
              center, launching a maternity home, funding mobile ultrasound
              units, or assisting post-abortive women on their healing journey,
              FundLife makes it easier to connect with compassionate donors who
              care deeply about protecting the unborn and supporting women in
              crisis.
              <br/>
              <br />
              In a culture where many fundraising platforms censor or
              marginalize pro-life efforts, FundLife provides a safe and
              welcoming space for life advocates. Our mission is simple: to help
              fund the future of the pro-life movement—one story, one project,
              one life at a time.
              <br/>
              <br />
              Join a growing community committed to compassion in action. At
              FundLife, you can donate or create and stand with those who stand
              for life.
            </div>
          </div>
        </div>

        <div className=" innercontainer py-4  mt-5 px-3">
          <div className="fs-1 fw-bold text-center"> About the Founder</div>
          <div className="d-sm-flex  gap-4 mt-4 ">
            <div className="text-center">
              <img src="/images/aboutus/founder.webp" alt="Founder" />
            </div>
            <div className=" ">
              <div className={style.aboutmike}  style={{ textAlign: "justify" }}>
                Mike Goss, a serial entrepreneur, has spent nearly five decades
                in various business ventures. For the last two, he prayed for an
                opportunity to use his entrepreneurial spirit to create a
                venture that could bring positive change to the lives of others.
                FundLife.me is the answer to that prayer.
                {/* Mike Goss is an entrepreneur at heart. A serial entrepreneur who
                has spent his entire adult life engaged in various business
                ventures. For the past decade, he has longed for a chance to use
                his hard-earned business knowledge to establish a venture that
                has a positive impact on the lives of others. FundLife is the
                result of that aspiration. */}
              </div>
              <div className={` ${style.aboutmike} my-3`} style={{ textAlign: "justify" }}>
                He’s often asked why he chose to address an issue that many
                seem indifferent to. He explains it: inequality. Goss believes it
                is a glaring injustice for a society to prioritize the right to
                ensure a woman&#39;s choice for abortion, while neglecting
                women who are struggling to avoid it, often for the second
                and third time. FundLife.me is his effort to correct this
                imbalance; a funding source for organizations that support
                women whose conscience dictates that they make a different
                choice. Goss views this as a fundamental principle of
                something we all desire: fairness.
                {/* He’s often asked why he chose to tackle an issue few seem to
                care about. He says he can sum it up in one word—injustice. He
                says he knows what injustice feels like. To grow up watching
                another receive preferential treatment is not something easily
                forgotten. As a result, treating others as I would like to be
                treated has become a core principle of his life. In simple
                terms, what you do for one, you do for the other. */}
              </div>
            </div>
          </div>

          {/* <div className="fs-5 my-3">
            He says he didn’t see that when he objectively assessed the
            overwhelming support provided for the abortion-minded woman versus
            the support offered to the abortion-vulnerable woman who’s
            desperately trying to avoid it, perhaps for the second or third
            time. The injustice of it is hard not to miss.
          </div>
          <div className="fs-5">
            Goss says for a movement built on freedom of choice, he thinks
            anyone would agree that it’s unjust for the pro-choice community to
            devote all their energies to one group of women facing unplanned
            pregnancy and none to the other. FundLife helps balance the scales
            of that injustice by making it easy for anyone to raise funds to
            help this ‘forgotten’ group of women who deserve just as much
            support as the others. <a href="#" className="fs-5" >The Happiest Day of My Life! </a> 
          </div> */}


        </div>
        {/* <div className="mt-5 py-4 px-3 px-sm-0">
          <Row className="m-0 p-0">
            <Col md={6} className="m-0 p-0 text-end">
              <img
                src={"/images/aboutus/image 13.webp"}
                alt="office"
                className="img-fluid w-100"
              />
            </Col>
            <Col
              md={6}
              className={`${style.aboutmission} m-0  d-flex justify-content-center align-items-center`}
              style={{ backgroundColor: "rgba(248, 113, 135, 0.2)" }}
            >
              <div style={{ maxWidth: "494px" }}>
                <div>
                  <img
                    src={"/images/aboutus/double.png"}
                    alt="comma"
                    className=""
                  />
                </div>
                <div className="fs-1 fw-bold ps-md-5 ps-0">Our Mission</div>
                <div className="ps-md-5 ps-0" style={{ textAlign: "justify" }}>
                  Fundlife exists to empower individuals, nonprofits, and
                  communities to bring their visions to life. We believe that
                  fundraising should be transparent, powerful, and people-first.
                  Our platform helps everyday changemakers raise funds with ease
                  and trust.
                </div>
              </div>
            </Col>
          </Row>
        </div> */}
        {/* <div className="mt-5 py-4">
          <Row className="m-0 p-0"
            style={{ backgroundColor: "rgba(34, 82, 118, 0.2)" }}

          >
            <Col
              md={6}
              className="m-0 p-0 d-flex justify-content-center align-items-center"
            >
              <div className={style.storyaboutus} style={{ maxWidth: "574px" }}>
                <div>
                  <img
                    src={"/images/aboutus/double2.png"}
                    alt="comma"
                    className=""
                  />
                </div>
                <div className="fs-1 fw-bold ps-md-5 ps-0">Our Story</div>
                <div className="ps-md-5 ps-0" style={{ textAlign: "justify" }}>
                  Founded with a belief that anyone can make a difference,
                  Fundlife began as a small initiative to support local causes.
                  Today, we've grown into a global platform, helping people
                  raise funds for medical needs, education, community projects,
                  disaster relief, and more.
                </div>
              </div>
            </Col>
            <Col md={6} className="m-0 p-0 ">
              <div>
                <img
                  src={"/images/aboutus/image 14.webp"}
                  alt="kids"
                  className={style.kidimg}
                />
              </div>
            </Col>
          </Row>

          <Row className="m-0 p-0">
            <Col
              md={6}
              className="m-0 p-0  d-flex justify-content-center align-items-center "
            >
              <img
                src={"/images/aboutus/volunteer.webp"}
                alt="vounteer"
                className="img-fluid w-100"
              />
            </Col>
            <Col
              md={6}
              className="m-0 p-0 d-flex justify-content-center align-items-center"
              style={{ backgroundColor: "#FFF1E5" }}
            >
              <div className="my-5" style={{ maxWidth: "574px" }}>
                <div className="fs-1 fw-bold text-center text-md-start">What We Stand For</div>
                <div className="fs-3 text-center text-md-start">(Our Values)</div>
                <Row className="mt-5">
                  <Col sm={6}>
                    <div className="d-flex gap-3">
                      <div>
                        <img src="/images/aboutus/shield.png" alt="trust" />
                      </div>
                      <div>
                        <div className="fs-5 fw-semibold">Trust</div>
                        <div>Transparent and secure giving</div>
                      </div>
                    </div>
                  </Col>
                  <Col sm={6}>
                    <div className="d-flex gap-3">
                      <div>
                        <img src="/images/aboutus/bulb.png" alt="innovation" />
                      </div>
                      <div>
                        <div className="fs-5 fw-semibold">Innovation</div>
                        <div>Smarter ways to raise funds</div>
                      </div>
                    </div>
                  </Col>
                </Row>
                <Row className="my-5">
                  <Col sm={6}>
                    <div className="d-flex gap-3">
                      <div>
                        <img src="/images/aboutus/helping.png" alt="Helping" />
                      </div>
                      <div>
                        <div className="fs-5 fw-semibold">Impact</div>
                        <div>Helping causes worldwide</div>
                      </div>
                    </div>
                  </Col>
                  <Col sm={6}>
                    <div className="d-flex gap-3">
                      <div>
                        <img src="/images/aboutus/empathy.png" alt="Empathy" />
                      </div>
                      <div>
                        <div className="fs-5 fw-semibold">Empathy</div>
                        <div>Compassion-led decisions</div>
                      </div>
                    </div>
                  </Col>
                </Row>
              </div>
            </Col>
          </Row>
        </div> */}

        <Newsletter />
      </div>
    </>
  );
};

export default AboutUs;
